export const TRANSLATION_KEYS = {
  // View filters
  VIEW_FILTER_ALL: {
    key: 'eventodeportivo_paises_tabs_texto_tab1',
  },
  VIEW_FILTER_FAVORITES: {
    key: 'eventodeportivo_paises_tabs_texto_tab2',
  },

  // Letter filter
  LETTER_FILTER_ALL: {
    key: 'eventodeportivo_paises_tabs1_texto_tab1',
  },
  LETTER_FILTER_A: {
    key: 'eventodeportivo_paises_tabs1_texto_tab2',
  },
  LETTER_FILTER_B: {
    key: 'eventodeportivo_paises_tabs1_texto_tab3',
  },
  LETTER_FILTER_C: {
    key: 'eventodeportivo_paises_tabs1_texto_tab4',
  },
  LETTER_FILTER_E: {
    key: 'eventodeportivo_paises_tabs1_texto_tab5',
  },
  LETTER_FILTER_F: {
    key: 'eventodeportivo_paises_tabs1_texto_tab6',
  },
  LETTER_FILTER_G: {
    key: 'eventodeportivo_paises_tabs1_texto_tab7',
  },
  LETTER_FILTER_H: {
    key: 'eventodeportivo_paises_tabs1_texto_tab8',
  },
  LETTER_FILTER_I: {
    key: 'eventodeportivo_paises_tabs1_texto_tab9',
  },
  LETTER_FILTER_J: {
    key: 'eventodeportivo_paises_tabs1_texto_tab10',
  },
  LETTER_FILTER_M: {
    key: 'eventodeportivo_paises_tabs1_texto_tab11',
  },
  LETTER_FILTER_N: {
    key: 'eventodeportivo_paises_tabs1_texto_tab12',
  },
  LETTER_FILTER_P: {
    key: 'eventodeportivo_paises_tabs1_texto_tab13',
  },
  LETTER_FILTER_R: {
    key: 'eventodeportivo_paises_tabs1_texto_tab17',
  },
  LETTER_FILTER_S: {
    key: 'eventodeportivo_paises_tabs1_texto_tab14',
  },
  LETTER_FILTER_T: {
    key: 'eventodeportivo_paises_tabs1_texto_tab15',
  },
  LETTER_FILTER_U: {
    key: 'eventodeportivo_paises_tabs1_texto_tab16',
  },

  ADD_TO_FAVORITES: {
    key: 'eventodeportivo_texto_agregarfavorito',
  },
  REMOVE_FROM_FAVORITES: {
    key: 'eventodeportivo_texto_quitarfavorito',
  },
  TOOLTIP_ADD_TO_FAVORITE: {
    key: 'eventodeportivo_texto_tooltip_agregarfavoritos',
  },
  TOOLTIP_REMOVE_FROM_FAVORITE: {
    key: 'eventodeportivo_texto_tooltip_quitarfavoritos',
  },

  // Empty state
  EMPTY_TITLE: {
    key: 'eventodeportivo_paises_contenedor_texto_parte1',
  },
  EMPTY_TEXT_1: {
    key: 'eventodeportivo_paises_contenedor_texto_parte2',
  },
  EMPTY_TEXT_2: {
    key: 'eventodeportivo_paises_contenedor_texto_parte3',
  },

  // Country Header
  BACK_BUTTON: {
    key: 'eventodeportivo_pais_boton_volver',
  },
  FAVORITE_COUNTRY: {
    key: 'eventodeportivo_pais_texto_paisfavorito',
  },
  ADD_COUNTRY_TO_FAVORITES: {
    key: 'eventodeportivo_pais_texto_agregarpaisfavoritos',
  },
  MATCHES: {
    key: 'eventodeportivo_paises_fichasuperior_texto_titulo_partidos',
  },
  POINTS: {
    key: 'eventodeportivo_paises_fichasuperior_texto_titulo_puntos',
  },
  FEATURED_PLAYERS: {
    key:
      'eventodeportivo_paises_fichasuperior_texto_titulo_jugadoresdestacados',
  },
  LAST_MATCHES: {
    key: 'eventodeportivo_paises_texto_titulo_ultimospartidos',
  },
};

export const COUNTRY_TRANSLATION_KEYS = {
  // A
  GERMANY: 'Mundial2026_WCCountries_Pais_Alemania',
  ALGERIA: 'Mundial2026_WCCountries_Pais_Argelia',
  ARGENTINA: 'Mundial2026_WCCountries_Pais_Argentina',
  SAUDI_ARABIA: 'Mundial2026_WCCountries_Pais_ArabiaSaudita',
  AUSTRALIA: 'Mundial2026_WCCountries_Pais_Australia',
  AUSTRIA: 'Mundial2026_WCCountries_Pais_Austria',

  // B
  BOSNIA_HERZEGOVINA: 'Mundial2026_WCCountries_Pais_BosniaHerzegovina',
  BRAZIL: 'Mundial2026_WCCountries_Pais_Brasil',
  BELGIUM: 'Mundial2026_WCCountries_Pais_Belgica',

  // C
  CANADA: 'Mundial2026_WCCountries_Pais_Canada',
  SOUTH_KOREA: 'Mundial2026_WCCountries_Pais_CoreaDelSur',
  CAPE_VERDE: 'Mundial2026_WCCountries_Pais_CaboVerde',
  CROATIA: 'Mundial2026_WCCountries_Pais_Croacia',
  COLOMBIA: 'Mundial2026_WCCountries_Pais_Colombia',
  IVORY_COAST: 'Mundial2026_WCCountries_Pais_CostaDeMarfil',
  CURACAO: 'Mundial2026_WCCountries_Pais_Curazao',

  // D
  DR_CONGO: 'Mundial2026_WCCountries_Pais_RepublicaDemocraticaDelCongo',

  // E
  ECUADOR: 'Mundial2026_WCCountries_Pais_Ecuador',
  EGYPT: 'Mundial2026_WCCountries_Pais_Egipto',
  SPAIN: 'Mundial2026_WCCountries_Pais_Espana',
  USA: 'Mundial2026_WCCountries_Pais_EstadosUnidos',

  // F
  FRANCE: 'Mundial2026_WCCountries_Pais_Francia',

  // G
  GHANA: 'Mundial2026_WCCountries_Pais_Ghana',

  // H
  HAITI: 'Mundial2026_WCCountries_Pais_Haiti',

  // I
  IRAN: 'Mundial2026_WCCountries_Pais_Iran',
  IRAQ: 'Mundial2026_WCCountries_Pais_Irak',

  // J
  JAPAN: 'Mundial2026_WCCountries_Pais_Japon',
  JORDAN: 'Mundial2026_WCCountries_Pais_Jordania',

  // M
  MOROCCO: 'Mundial2026_WCCountries_Pais_Marruecos',
  MEXICO: 'Mundial2026_WCCountries_Pais_Mexico',

  // N
  NORWAY: 'Mundial2026_WCCountries_Pais_Noruega',
  NEW_ZEALAND: 'Mundial2026_WCCountries_Pais_NuevaZelanda',

  // P
  NETHERLANDS: 'Mundial2026_WCCountries_Pais_PaisesBajos',
  PANAMA: 'Mundial2026_WCCountries_Pais_Panama',
  PARAGUAY: 'Mundial2026_WCCountries_Pais_Paraguay',

  // Q
  QATAR: 'Mundial2026_WCCountries_Pais_Qatar',

  // R
  CZECH_REPUBLIC: 'Mundial2026_WCCountries_Pais_RepublicaCheca',

  // S
  SOUTH_AFRICA: 'Mundial2026_WCCountries_Pais_Sudafrica',
  SENEGAL: 'Mundial2026_WCCountries_Pais_Senegal',
  SWEDEN: 'Mundial2026_WCCountries_Pais_Suecia',
  SWITZERLAND: 'Mundial2026_WCCountries_Pais_Suiza',

  // T
  TURKEY: 'Mundial2026_WCCountries_Pais_Turquia',
  TUNISIA: 'Mundial2026_WCCountries_Pais_Tunez',

  // U
  URUGUAY: 'Mundial2026_WCCountries_Pais_Uruguay',
  UZBEKISTAN: 'Mundial2026_WCCountries_Pais_Uzbekistan',
};
